/**
 * @Description 登录页
 */
import { get, post } from '@/common/request/index';

/**
 * 发送语音验证码
 * https://yapi.lanhanba.com/project/297/interface/api/84300
 */
export function sendVoiceCode(params: any) {
  return get('/sendVoiceCode', params, {
    isMock: false,
    mockId: 297,
    needHint: true,
  });
}

/**
 * 登录
 * https://yapi.lanhanba.com/project/297/interface/api/33439
 */
export function fetchLogin(params: any) {
  return post('/login', params, {
    isMock: false,
    mockId: 297,
    needHint: true,
  });
}


/**
 * 登录时自动注册
 * https://yapi.lanhanba.com/project/297/interface/api/86456
 */
export function loginAndRegister(params: any) {
  return post('/loginAndRegister', params, {
    isMock: false,
    mockId: 297,
    needHint: true,
  });
}
